export default __webpack_public_path__ + "static/media/home-preview-payments.a472d97f.jpg";